import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { ContractCreateEditProvider } from './context/contract-create-edit-context';
import { CreateEditContractComponent } from './contract-create-edit-component';

export function ContractCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <ContractCreateEditProvider>
                <CreateEditContractComponent />
            </ContractCreateEditProvider>
        </BaseLayoutFactory>
    );
}
